import digitalData from 'digital-data';
import { getCategoryBreadCrumbs, makeEverythingLowerCase, setAnalytics } from '../../../thd-analytics-utils.js';
export function seoExperience() {
  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('seo-experience.page-load', _ref => {
    var _product$identifiers, _digitalData$page, _digitalData$page2;
    let {
      output = {}
    } = _ref;
    const product = (output === null || output === void 0 ? void 0 : output.product) || '';
    const pageType = (output === null || output === void 0 ? void 0 : output.pageType) || '';
    const {
      breadCrumbs = []
    } = (product === null || product === void 0 ? void 0 : product.taxonomy) || {};
    const sku = (product === null || product === void 0 ? void 0 : (_product$identifiers = product.identifiers) === null || _product$identifiers === void 0 ? void 0 : _product$identifiers.omsThdSku) || '';
    digitalData.page = {
      pageInfo: {
        abTest: '',
        pageName: `${pageType}>${sku}`,
        pageType: `tool:${pageType}:pip`,
        pageLoadEvent: ''
      },
      category: getCategoryBreadCrumbs(breadCrumbs)
    };
    digitalData.page.pageInfo = makeEverythingLowerCase(digitalData === null || digitalData === void 0 ? void 0 : (_digitalData$page = digitalData.page) === null || _digitalData$page === void 0 ? void 0 : _digitalData$page.pageInfo);
    digitalData.page.category = makeEverythingLowerCase(digitalData === null || digitalData === void 0 ? void 0 : (_digitalData$page2 = digitalData.page) === null || _digitalData$page2 === void 0 ? void 0 : _digitalData$page2.category);
    setAnalytics(digitalData);
  });
}
//# sourceMappingURL=seo-experience.js.map